<script>
  /* global Global */
  import Header from '../common/Header.svelte';
  import Loading from '../common/Loading.svelte';
  import Common from '../js/common.js';

  let lang;

  (async () => {
    // eslint-disable-next-line no-undef
    await fetch(`${Common.BACKEND_URL}/user/logout`);

    window.localStorage.removeItem('user');
    window.location.href = window.localStorage.getItem('currentPage') || './';
  })();

  const i18n = {
    pageTitle: {
      cs: `Odhlásit se | ${Global.project.name.cs}`,
      en: `Logout | ${Global.project.name.en}`,
    },
  };
</script>

<svelte:head>
  <title> {i18n.pageTitle[lang]} </title>
</svelte:head>

<Header page='logout' savePage={false} bind:lang/>

<Loading display={true} fullHeight={true}/>
